import { useState } from 'react';
import PromotionPosts from '../../services/promotionPosts';

const usePromotionPosts = () => {
  const [promotionPosts, setPromotionPosts] = useState([]);
  const [promotionPostsLoading, setPromotionPostsLoading] = useState(false);
  const [promotionPostsError, setPromotionPostsError] = useState(null);

  const loadPromotionPosts = async () => {
    try {
      setPromotionPostsLoading(true);
      const resp = await PromotionPosts.getAll();
      setPromotionPosts(resp.data.data);
      setPromotionPostsError(null);
    } catch (error) {
      setPromotionPostsError(error);
    } finally {
      setPromotionPostsLoading(false);
    }
  };

  return [promotionPosts, promotionPostsLoading, promotionPostsError, loadPromotionPosts];
};

export default usePromotionPosts;
